import React, {Component} from 'react';
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import { Table } from 'semantic-ui-react'
import {getChartColors, minutesToHuman} from '../../Helpers'
import {Pie} from 'react-chartjs-2';
import PropTypes from 'prop-types';
class ReportCommesseLavoratoriPerAnnoDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items:[],
            total: 0,
            durataTotale: 0,
            durataPesataTotale: 0,
            numAttivitaTotale: 0,
            _loading: false,
            error: null,
        };
        this.loadData = this.loadData.bind(this)
    }

    componentWillUnmount() {
    }

    componentDidMount() {
        this.loadData(this.props.commessa.idCommessa, this.props.anno);
    }

    componentWillReceiveProps(nextProps){
        if (nextProps.commessa !== this.props.commessa || nextProps.anno !== this.props.anno )
        {
            this.loadData(nextProps.commessa.idCommessa, nextProps.anno);
        }
    }

    loadData(idCommessa, anno) {
        let filterInfo = this.state.filterInfo;
        let dataStart = anno + "-01-01";
        let dataEnd = anno + "-12-31";
        this.setState({_loading: true});
        client.loadReportAttivita(
            undefined, dataStart, dataEnd, idCommessa,''
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        items: data.items,
                        total: data.total,
                        durataTotale: data.durataTotale,
                        durataPesataTotale: data.durataPesataTotale,
                        numAttivitaTotale: data.numAttivitaTotale,
                        filterInfo: filterInfo,
                        _loading: false,
                        error: null
                    })
                })
            }
            else if (response.status === 401)
            {
                this.context.router.transitionTo("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });
    }

    render() {
        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }
        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui loader"></div>
                </div>
            );
        }
        let i = 0;

        const tableClass = "sixteen wide column"
        const chartClass = ""

        return (<div className="ui two columns grid">
            {/*Qui ci va la tabella*/}
            <div className={tableClass}>

                <Table celled>
                    {/*<Table.Header>*/}
                    {/*    <Table.Row>*/}
                    {/*        <Table.HeaderCell>*/}
                    {/*            Utente*/}
                    {/*        </Table.HeaderCell>*/}
                    {/*        <Table.HeaderCell textAlign='center'>*/}
                    {/*            Numero Attività*/}
                    {/*        </Table.HeaderCell>*/}
                    {/*        <Table.HeaderCell textAlign='center'>*/}
                    {/*            Durata Totale (minuti)*/}
                    {/*        </Table.HeaderCell>*/}
                    {/*        <Table.HeaderCell textAlign='center'>*/}
                    {/*            Durata Totale (h:m:s)*/}
                    {/*        </Table.HeaderCell>*/}
                    {/*    </Table.Row>*/}
                    {/*</Table.Header>*/}
                    <Table.Body>
                            <Table.Row style={{fontWeight: 'bold', height: '100px'}}>
                                <Table.Cell>
                                    Utente
                                </Table.Cell>
                                <Table.Cell textAlign='center'>
                                    Numero Attività
                                </Table.Cell>
                                <Table.Cell textAlign='center'>
                                    Durata Totale
                                </Table.Cell>
                                <Table.Cell textAlign='center'>
                                    Durata Totale (h:m)
                                </Table.Cell>
                            </Table.Row>
                        {
                            this.state.items.map((item) => {
                                return <Table.Row key={i++}>
                                    <Table.Cell>{item.utente.username}</Table.Cell>
                                    <Table.Cell  textAlign='center'>{item.numAttivita}</Table.Cell>
                                    <Table.Cell  textAlign='center'>{item.durataPesata}</Table.Cell>
                                    <Table.Cell  textAlign='center'>{minutesToHuman(item.durataPesata)}</Table.Cell>
                                </Table.Row>
                            })}
                    </Table.Body>
                    <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell  textAlign="right">Totali</Table.HeaderCell>
                            <Table.HeaderCell  textAlign='center'><b>{this.state.numAttivitaTotale}</b></Table.HeaderCell>
                            <Table.HeaderCell  textAlign='center'><b>{this.state.durataPesataTotale}</b></Table.HeaderCell>
                            <Table.HeaderCell  textAlign='center'><b>{minutesToHuman(this.state.durataPesataTotale)}</b></Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
                </Table>

            </div>
            {loader}
        </div>)
    }
}

ReportCommesseLavoratoriPerAnnoDetail.PropTypes = {
    commessa: PropTypes.object.isRequired,
    anno: PropTypes.string.isRequired,
    viewCharts: PropTypes.bool.isRequired,
}


ReportCommesseLavoratoriPerAnnoDetail.defaultProps = {
    viewCharts: false,
};

export default ReportCommesseLavoratoriPerAnnoDetail;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportCommesseLavoratoriPerAnnoDetail.js
 **/